import React from 'react'
import '../../styles/quality.css'
import QualityBox from './QualityBox';

const Dataquality = () => {
    const content = [
        {
            title:"Lorem ipsum dolor sit",
            content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim"
        },
        {
            title:"Lorem ipsum dolor sit",
            content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim"
        },
        {
            title:"Lorem ipsum dolor sit",
            content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim"
        },
        {
            title:"Lorem ipsum dolor sit",
            content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim"
        },
        {
            title:"Lorem ipsum dolor sit",
            content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim"
        },
        {
            title:"Lorem ipsum dolor sit",
            content:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim"
        }

    ]
  return (
    <div className='container quality-container'>
        <p className='quality-title'>data qulaity</p>
        <h1 className='quality-main-heading'>How we improve the data quality</h1>
       <div className="quality-box-container">
        {
            content.map((val,i)=>(
                <QualityBox
                key={i}
                title={val.title}
                content={val.content}
                ></QualityBox>
            ))
        }
       </div>
       <p className='quality-sub-para'>QuickSurvey empowers clients to create, launch, and analyze surveys to gather valuable insights from their target audience. The platform's streamlined process, precision targeting, real-time responses, and actionable insights make it a powerful tool for making data-driven decisions and enhancing various aspects of business strategies.</p>
    </div>
  )
}

export default Dataquality;